<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title class="mt-4">
          <v-btn
            v-if="$route.name != `ProfilePage`"
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          <span>
            {{
              $route.name == "ProfilePage" ? `My Profile` : `Edit User`
            }}</span
          >
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="4">
              <v-text-field
                v-model="form.first_name"
                outlined
                label="First Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.first_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.middle_name"
                outlined
                label="Middle Name"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.middle_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.last_name"
                outlined
                label="Last Name *"
                prepend-inner-icon="mdi-buffet"
                :error-messages="errors.last_name"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.email"
                outlined
                label="Email *"
                prepend-inner-icon="mdi-email"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col sm="4">
              <v-text-field
                v-model="form.phone"
                outlined
                label="Phone *"
                prepend-inner-icon="mdi-phone"
                :error-messages="errors.phone"
              ></v-text-field>
            </v-col>
            <v-col sm="4" v-if="$route.name != 'ProfilePage'">
              <v-autocomplete
                ref="position"
                outlined
                v-model="form.position_id"
                :items="positionItems"
                label="Position *"
                prepend-inner-icon="mdi-account-tie-outline"
                clearable
                :error-messages="errors.position_id"
              ></v-autocomplete>
            </v-col>
            <!-- Therapy-specific fields for Ambler Gait Therapy -->
            <v-col sm="6" v-if="form.position_id == 3">
              <v-text-field
                v-model="form.height"
                outlined
                label="Height (cm)"
                prepend-inner-icon="mdi-human-male-height"
                type="number"
                step="0.01"
                :error-messages="errors.height"
              ></v-text-field>
            </v-col>
            <v-col sm="6" v-if="form.position_id == 3">
              <v-text-field
                v-model="form.weight"
                outlined
                label="Weight (kg)"
                prepend-inner-icon="mdi-scale"
                type="number"
                step="0.01"
                :error-messages="errors.weight"
              ></v-text-field>
            </v-col>
            <v-col sm="12" v-if="form.position_id == 3">
              <v-textarea
                v-model="form.diagnosis"
                outlined
                label="Medical Diagnosis"
                prepend-inner-icon="mdi-clipboard-text"
                rows="3"
                :error-messages="errors.diagnosis"
              ></v-textarea>
            </v-col>
            <v-col sm="12" v-if="form.position_id == 3">
              <v-textarea
                v-model="form.therapy_goals"
                outlined
                label="Therapy Goals & Objectives"
                prepend-inner-icon="mdi-target"
                rows="3"
                :error-messages="errors.therapy_goals"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-switch
                class="mt-0 ml-5"
                v-model="form.is_active"
                inset
                :label="`Is Active: ${form.is_active ? 'YES' : 'NO'}`"
              ></v-switch>
            </v-col>
          </v-row>
          <v-btn
            :loading="isLoading"
            :disabled="isLoading"
            color="primary"
            rounded
            dark
            @click="save"
          >
            Update {{ $route.name == "ProfilePage" ? `Profile` : `User` }}
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "@/axios";
export default {
  name: "UserEditPage",
  data() {
    return {
      form: {},
      isLoading: false,
      positionItems: [],
    };
  },
  computed: {
    errors() {
      return this.$store.getters["errors/getErrors"];
    },
  },
  mounted() {
    this.getMasters();
    this.getData();
  },
  methods: {
    async getMasters() {
      try {
        const response = await axios.get(`masters?context=user`);
        const masters = response.data;
        console.log("Masters response:", masters);
        // get logged in user position from localStorage / Vuex / API
        const loggedInUser = this.user;
        
        const userPosition = loggedInUser?.position?.name; // adjust if you store id instead of name
        
        console.log("loggedInUser", userPosition);
        // Clear previous items
        this.positionItems = [];

        // Filter positions
        masters.positions.forEach((position) => {
          if (userPosition === "HOSPITAL ADMIN") {
            // Show only THERAPIST in dropdown
            if (position.name === "THERAPIST") {
              this.positionItems.push({
                id: position.id,
                text: position.name,
                value: position.id,
              });
            }
          } else {
            // Other users see all positions
            this.positionItems.push({
              id: position.id,
              text: position.name,
              value: position.id,
            });
          }
        });
      } catch (error) {
        console.log(error);
        // redirect to Home Page
        //window.location.href = "/auth/login";
      }
    },
    async getData() {
      this.isLoading = true;
      let encryptedId = this.$route.params.userId;
      axios
        .get(`/users/${encryptedId}`)
        .then((response) => {
          this.form = response.data.data;
          console.log(this.form);
          this.old_json = response.data.data;
        })
        .catch((error) => {
          // redirect to Home Page
          // //window.location.href = "/auth/login";
          console.error("Error fetching data:", error);
        });
      this.isLoading = false;
    },
    async save() {
      try {
        this.isLoading = true;
        await axios
          .patch(`/users/${this.$route.params.userId}`, this.form)
          .then(async () => {
            await this.saveUserTimestamp(this.old_json, this.form);
          })
          .catch((error) => {
            // redirect to Home Page
            // //window.location.href = "/auth/login";
            console.error("Error fetching data:", error);
          });
        this.isLoading = false;
        if (this.$route.name == "ProfilePage") {
          // this.$router.push("/supervisor");
          // //window.location.href = "/auth/login";
        } else {
          this.$router.push("/users");
        }
      } catch (e) {
        this.isLoading = false;
      }
    },
  },
};
</script>
